/** Course details URL with accordion chapter expanded via ?chapter= */
export function courseChapterPath(sectionOrId, chapterKey) {
  const courseId =
    sectionOrId != null && typeof sectionOrId === "object"
      ? sectionOrId.id
      : sectionOrId;
  if (!courseId || chapterKey == null || chapterKey === "") {
    return "/students/courses";
  }
  const qs = new URLSearchParams({ chapter: String(chapterKey) }).toString();
  return `/students/courses/${courseId}?${qs}`;
}
